import Vue from "vue";
import axios from "axios";
import qs from "qs";
import VueAxios from "vue-axios";
import JwtService from "@/common/jwt.service";
import { API_URL } from "@/common/config";

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
  },
  setHeader() {
    if (JwtService.getToken() !== "" && JwtService.getToken() !== null) {
      Vue.axios.defaults.headers.common[
        "Authorization"
        ] = `Bearer ${JwtService.getToken()}`;
    }
  },

  query(resource, params) {
    this.setHeader();

    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`ApiService ${error}` + ` HttpCode:${error.response.status}`);
    });
  },

  get(resource, slug = "") {
    this.setHeader();

    return Vue.axios.get(`${resource}${slug}/`).catch(error => {
      throw new Error(`ApiService ${error}` + ` HttpCode:${error.response.status}`);
    });
  },

  get2(resource, slug = "") {
    this.setHeader();

    return Vue.axios.get(`${resource}${slug}`).catch(error => {
      throw new Error(`ApiService ${error}`);
    });
  },

  post(resource, params) {
    this.setHeader();

    return Vue.axios.post(`${resource}`, params);
  },

  postForm(resource, form) {
    this.setHeader();

    return Vue.axios.post(`${resource}`, form, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  update(resource, slug, params) {
    this.setHeader();

    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  put(resource, params) {
    this.setHeader();

    return Vue.axios.put(`${resource}`, params);
  },

  delete(resource) {
    this.setHeader();

    return Vue.axios.delete(resource).catch(error => {
      throw new Error(`ApiService ${error}`);
    });
  }
};

export default ApiService;

export const ProjectsService = {
  list(type, params) {
    return ApiService.query("projects/getListProjects/", {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  getLinkReestrProjectExcel(params) {
    return ApiService.query("projects/getLinkReestrProjectExcel/", {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  userProgrammes(params) {
    return ApiService.query("projects/getListProgramAddProject/", {
      params: params
    });
  },
  addProject(params) {
    return ApiService.post("projects/addProject/", params);
  },
  saveProject(params, step) {
    return ApiService.post(
      `projects/editProject/${params.ID}/?step=${step}`,
      params
    );
  },
  sendProject(params) {
    return ApiService.post(`projects/sendProject/${params.ID}/`, params);
  },
  reSendProject(params) {
    return ApiService.post(
      `projects/sendProjectResending/${params.ID}/`,
      params
    );
  },
  get(slug) {
    //return ApiService.get("projects/getProject/", slug);
    return ApiService.get2("projects/getProject/", slug);
  },
  getMainInfo(slug) {
    return ApiService.get("projects/getProjectMainInfo/", slug);
  },
  getStatusHistory(slug) {
    return ApiService.get("projects/getHistoryStatusProject/", slug);
  },
  getSpElectronicListByProject(id) {
    return ApiService.get(`projects/getSpElectronicListByProject/${id}`);
  },
  calcSum(id, params) {
    return ApiService.post(`projects/getAllSumZaim/${id}/`, params);
  },
  getNewIndicticatorByChangeMonthProject(id, params) {
    return ApiService.post(
      `projects/getNewIndicticatorByChangeMonthProject/${id}/`,
      params
    );
  },
  changeStavkaProcentProject(id, params) {
    return ApiService.post(
      `projects/changeStavkaProcentProject/${id}/`,
      params
    );
  },
  changeAcceptProject(id, params) {
    return ApiService.post(`projects/changeAcceptProject/${id}/${params}/`);
  },
  changeAcceptCalendarPlan(id, params) {
    return ApiService.post(
      `projects/changeAcceptCalendarPlan/${id}/${params}/`
    );
  },
  changeAcceptEquipment(id, params) {
    return ApiService.post(`projects/changeAcceptEquipment/${id}/${params}/`);
  },
  setNewStatusProject(id, params) {
    return ApiService.post(`projects/setNewStatusProject/${id}/`, params);
  },
  setNewStatusProjectBySecterary(id, params) {
    return ApiService.post(
      `projects/setNewStatusProjectBySecterary/${id}/`,
      params
    );
  },
  setNewStatusProjectByOmpStaff(id, params) {
    return ApiService.post(
      `projects/setNewStatusProjectByOmpStaff/${id}/`,
      params
    );
  },
  clearAttributeDZProjectByOmpStaff(id) {
    return ApiService.post(`projects/clearAttributeDZProjectByOmpStaff/${id}/`);
  },
  changeManagerProject(id, params) {
    return ApiService.post(`projects/changeManagerProject/${id}/`, params);
  },
  changeManagerDSPProject(id, params) {
    return ApiService.post(`projects/changeManagerDSPProject/${id}/`, params);
  },
  changeManagerRFRPProject(id, params) {
    return ApiService.post(`projects/changeManagerRFRPProject/${id}/`, params);
  },
  setStatusEmailSendManagerOSPProject(id, params) {
    return ApiService.post(
      `projects/setStatusEmailSendManagerOSPProject/${id}/`,
      params
    );
  },
  setStatusEmailSendManagerRFRPProject(id, params) {
    return ApiService.post(
      `projects/setStatusEmailSendManagerRFRPProject/${id}/`,
      params
    );
  },
  readAlertProject(slug) {
    return ApiService.get(`projects/getReadAlertProject/`, slug);
  },
  setReadAlertProject(id) {
    return ApiService.post(`projects/setReadAlertProject/${id}/`);
  },
  getListProjectsForRequest(params) {
    //return ApiService.get(`projects/getListProjectsForRequest`, slug);
    return ApiService.query("projects/getListProjectsForRequest", {
      params: params
    });
  },
  getFindOrgByGetWay(params) {
    return ApiService.query("orgs/getFindOrgByGetWay", {
      params: params
    });
  },
  getOgrnInfo(id) {
    return ApiService.get(`orgs/getOrgByOGRN/${id}`);
  },
  downloadFileSnils(id, params) {
    return ApiService.post(`orgs/downloadFileSnils/${id}/`, params);
  },
  downloadFileSnilsContact(id, contactId, params) {
    return ApiService.post(
      `orgs/downloadFileSnilsContact/${id}/${contactId}/`,
      params
    );
  },
  editWebSite(id, params) {
    return ApiService.post(`orgs/editWebSite/${id}/`, params);
  },
  addAddress(id, typeId, params) {
    return ApiService.post(`orgs/addAddress/${id}/${typeId}/`, params);
  },
  addManager(id, params) {
    return ApiService.post(`projects/setAllManagerProject/${id}/`, params);
  },
  editAddress(id, typeId, params) {
    return ApiService.post(`orgs/editAddress/${id}/${typeId}/`, params);
  },
  saveAcceptContact(projectId, id, params) {
    return ApiService.post(
      `orgs/saveAcceptContact/${projectId}/${id}/`,
      params
    );
  },
  addOrgLizing(projectId, params) {
    return ApiService.post(`orgs/addOrgLizing/${projectId}/`, params);
  },
  addContacts(id, projectId, params) {
    return ApiService.post(`orgs/addContacts/${id}/${projectId}/`, params);
  },
  editContacts(id, projectId, params) {
    return ApiService.post(`orgs/editContacts/${id}/${projectId}/`, params);
  },
  deleteContacts(id, projectId, contactId) {
    return ApiService.delete(
      `orgs/deleteContact/${id}/${projectId}/${contactId}/`
    );
  },
  deleteAddress(idOrg, idAddress) {
    return ApiService.delete(`orgs/deleteAddress/${idOrg}/${idAddress}/`);
  },
  getManagerRoleDefaultSetting() {
    return ApiService.get(`projects/getManagerRoleDefaultSetting`);
  },
  getListByProjectCoordinations(id) {
    return ApiService.get(`projects/getListByProjectCoordinations/${id}`);
  },
  setByProjectCoordinations(id, params) {
    return ApiService.post(`projects/setByProjectCoordinations/${id}`, params);
  },
  getListManagerProject() {
    return ApiService.get(`projects/getListManagerProject`);
  },
  getListManagerDSPProject() {
    return ApiService.get(`projects/getListManagerDSPProject`);
  },
  getListManagerEAProject() {
    return ApiService.get(`projects/getListManagerEAProject`);
  },
  getListManagerRFRPProject(id) {
    return ApiService.get(`projects/getListManagerRFRPProject/${id}`);
  },
  getLinkTemplateConformityUrl(id) {
    return ApiService.get(`projects/getLinkTemplateConformityUrl/${id}`);
  },
  getPrintPDFUrl(id) {
    return ApiService.get(`projects/getPrintPDFUrl/${id}`);
  },
  getLinkIndicatorsByOrgExcel(id) {
    return ApiService.get(`indicatorsOrg/getLinkIndicatorsByOrgExcel/${id}`);
  },
  getZakluchenieMinProm(id) {
    return ApiService.get(`projects/getZakluchenieMinProm/${id}`);
  },
  editZakluchenieMinProm(id, params) {
    return ApiService.post(`projects/editZakluchenieMinProm/${id}/`, params);
  },
  getAboutProject(id) {
    return ApiService.get(`projects/getAboutProject/${id}`);
  },
  getScenarioProject(id) {
    return ApiService.get(`projects/getScenarioProject/${id}`);
  },
  editZakluchenieMinPromByExpertise(id, params) {
    return ApiService.post(
      `projects/editZakluchenieMinPromByExpertise/${id}/`,
      params
    );
  },
  getScenarioProjectBlock(id, params) {
    return ApiService.post(`projects/getScenarioProjectBlock/${id}`, params);
  },
  getPlanPrintPDFUrl(id) {
    return ApiService.get(`plan/getPrintPDFUrl/${id}`);
  },
  getLinkTemplateMismatchUrl(id) {
    return ApiService.get(`projects/getLinkTemplateMismatchUrl/${id}`);
  },
  getShablonTrust() {
    return ApiService.get(`orgs/getShablonTrust`);
  },
  getRulesChangeStatusUser(id) {
    if (id > 0) {
      return ApiService.get(`projects/getRulesChangeStatusUser/${id}`);
    }
  },
  getCoAuthorInfoByOgrn(ogrn) {
    return ApiService.get(`projects/getCoAuthorInfoByOgrn/${ogrn}`);
  },
  getCoAuthorInfoByOgrn2(ogrn, params) {
    if (params["UF_NAME"] != "") {
      return ApiService.query(`projects/getCoAuthorInfoByOgrn/${ogrn}`, {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { encode: false });
        }
      });
    } else {
      return ApiService.get(`projects/getCoAuthorInfoByOgrn/${ogrn}`);
    }
  },
  bpStatus(idBP, idStatus) {
    return ApiService.get2(`directory/bp/${idBP}/${idStatus}`);
  },
  getDirectoryExcel(name) {
    ApiService.setHeader();

    return Vue.axios.get(`directory/excel/${name}`, {
      responseType: "blob"
    });
  },
  getLinkFileDownloadUploadES(id) {
    return ApiService.get(`documents/getLinkFileDownloadUploadES/${id}`);
  },
  getDocumentESProjects(id) {
    return ApiService.get(`documents/getDocumentESProjects/${id}`);
  },
  getDocumentDZProjects(id) {
    return ApiService.get(`documents/getDocumentDZProjects/${id}`);
  },
  getBlockTypeDocDocumentDZ(id, idBlock) {
    return ApiService.get(
      `documents/getBlockTypeDocDocumentDZ/${id}/${idBlock}`
    );
  },
  getTypeFileExtensionForUserRequest() {
    return ApiService.get(`documents/getTypeFileExtensionForUserRequest`);
  },
  getHistoryVersionDocument(id, fileId) {
    return ApiService.get(
      `documents/getHistoryVersionDocument/${id}/${fileId}`
    );
  },
  getListIR(id) {
    return ApiService.get(`ir/getListIRProject/${id}`);
  },
  addIR(id) {
    return ApiService.post(`ir/addIRProject/${id}/`);
  },
  deleteIR(id, recordId) {
    return ApiService.delete(`ir/deleteIRProject/${id}/${recordId}/`);
  },
  updateIR(id, recordId, params) {
    return ApiService.post(`ir/editIRProject/${id}/${recordId}/`, params);
  },
  getListMeetingsProject(id) {
    return ApiService.get(`meetings/getListMeetingsProject/${id}`);
  },
  addMeetingProject(id, params) {
    return ApiService.post(`meetings/addMeetingProject/${id}/`, params);
  },
  deleteMeetingProject(id, recordId) {
    return ApiService.delete(
      `meetings/deleteMeetingProject/${id}/${recordId}/`
    );
  },
  editMeetingProject(id, recordId, params) {
    return ApiService.post(
      `meetings/editMeetingProject/${id}/${recordId}/`,
      params
    );
  },
  addNewDocument(id, params) {
    return ApiService.post(`documents/addNewDocument/${id}/`, params);
  },
  editDocument(id, docId, params) {
    return ApiService.post(`documents/editDocument/${id}/${docId}/`, params);
  },
  addRequestDocument(id, params) {
    return ApiService.post(`documents/addRequestDocument/${id}/`, params);
  },
  addRequestDocumentDZ(id, idType, params) {
    return ApiService.post(
      `documents/addRequestDocumentDZ/${id}/${idType}/`,
      params
    );
  },
  saveAcceptDocument(id, params) {
    return ApiService.post(`documents/saveAcceptDocument/${id}/`, params);
  },
  editRequestDocument(id, docId, params) {
    return ApiService.post(
      `documents/editRequestDocument/${id}/${docId}/`,
      params
    );
  },
  addZalogFaceBlockDocumentDZ(id, params) {
    return ApiService.post(
      `documents/addZalogFaceBlockDocumentDZ/${id}/`,
      params
    );
  },
  updateIsViewEs(id, docId, params) {
    return ApiService.put(
      `documents/updateIsViewEs/${id}/${docId}/`,
      params
    );
  },
  deleteZalogFaceBlockDocumentDZ(id, idZalogFaceid) {
    return ApiService.delete(
      `documents/deleteZalogFaceBlockDocumentDZ/${id}/${idZalogFaceid}/`
    );
  },
  deleteDocument(id, docId, params) {
    return ApiService.delete(
      `documents/deleteDocument/${id}/${docId}/`,
      params
    );
  },
  deleteDocumentDZ(id, docId, params) {
    return ApiService.delete(
      `documents/deleteDocumentDZ/${id}/${docId}/`,
      params
    );
  },
  saveDocument(id, form, params) {
    return ApiService.postForm(`documents/saveDocument/${id}/`, form, params);
  },
  saveDocumentDZ(id, form, params) {
    return ApiService.postForm(`documents/saveDocumentDZ/${id}/`, form, params);
  },
  getHashFile(form) {
    return ApiService.postForm(`documents/getHashFile`, form);
  },
  saveDogovorZaimDZ(id, form, params) {
    return ApiService.postForm(
      `documents/saveDogovorZaimDZ/${id}/`,
      form,
      params
    );
  },
  sendDogovorZaimDZByDirectum(idFileDZ, params) {
    return ApiService.post(
      `documents/sendDogovorZaimDZByDirectum/${idFileDZ}/`,
      params
    );
  },
  setElectornViewManagerDocumentDZ(id, idFile, params) {
    return ApiService.post(
      `documents/setElectornViewManagerDocumentDZ/${id}/${idFile}/`,
      params
    );
  },
  setPaperViewManagerDocumentDZ(id, idFile, params) {
    return ApiService.post(
      `documents/setPaperViewManagerDocumentDZ/${id}/${idFile}/`,
      params
    );
  },
  setCommentManagerDocumentDZ(id, idFile, params) {
    return ApiService.post(
      `documents/setCommentManagerDocumentDZ/${id}/${idFile}/`,
      params
    );
  },
  setAkceptRFRPManagerDocumentDZ(id, idFile, params) {
    return ApiService.post(
      `documents/setAkceptRFRPManagerDocumentDZ/${id}/${idFile}/`,
      params
    );
  },
  addBlockDocumentDZ(id, params) {
    return ApiService.post(`documents/addBlockDocumentDZ/${id}/`, params);
  },
  editBlockDocumentDZ(id, idModel, params) {
    return ApiService.post(
      `documents/editBlockDocumentDZ/${id}/${idModel}/`,
      params
    );
  },
  deleteBlockDocumentDZ(id, idModel) {
    return ApiService.delete(
      `documents/deleteBlockDocumentDZ/${id}/${idModel}/`
    );
  },
  editNameRequestDocumentDZ(id, idFile, params) {
    return ApiService.post(
      `documents/editNameRequestDocumentDZ/${id}/${idFile}/`,
      params
    );
  },
  loadPlan(id) {
    return ApiService.get(`plan/getPlanProject/${id}`);
  },
  getDocumenetHistoryDZ(id, idFile) {
    return ApiService.get(`documents/getDocumenetHistoryDZ/${id}/${idFile}`);
  },
  async getBlockDocumentDZ(id) {
    return await ApiService.get(`documents/getBlockDocumentDZ/${id}`);
  },
  deleteFileDZ(id, idFile, params) {
    return ApiService.post(`documents/deleteFileDZ/${id}/${idFile}/`, params);
  },
  saveLogViewDocument(id) {
    return ApiService.post(`documents/saveLogViewDocument/${id}/`);
  },
  getLinkFileArhiveAndExpertises(id) {
    return ApiService.get(`documents/getLinkFileArhiveAndExpertises/${id}`);
  },
  getPrintPlanDocxUrl(id) {
    return ApiService.get(`plan/getPrintPlanDocxUrl/${id}`);
  },
  getPrintTZDocxUrl(id) {
    return ApiService.get(`projects/getPrintTZDocxUrl/${id}`);
  },
  getPrintBudgetDocxUrl(id) {
    return ApiService.get(`projects/getPrintBudgetDocxUrl/${id}`);
  },
  getPrintIndicatorsDocxUrl(id) {
    return ApiService.get(`projects/getPrintIndicatorsDocxUrl/${id}`);
  },
  getLinkFileArhive(id) {
    return ApiService.get(`documents/getLinkFileArhive/${id}`);
  },
  getLinkFileECP(projectID, id, format) {
    return ApiService.get(
      `documents/getLinkFileECP/${projectID}/${id}/${format}`
    );
  },
  getECPInfoFile(projectID, idFile) {
    return ApiService.get(`documents/getECPInfoFile/${projectID}/${idFile}`);
  },
  getECPInfoFileDZ(projectID, idFile) {
    return ApiService.get(`documents/getECPInfoFileDZ/${projectID}/${idFile}`);
  },
  getLinkFileArhiveDZ(id) {
    return ApiService.get(`documents/getLinkFileArhiveDZ/${id}`);
  },
  getLinkGenerateLetterDZ(id) {
    return ApiService.get(`documents/getLinkByLetterDZ/${id}`);
  },
  getLinkGenerateRemainderDZ(id) {
    return ApiService.get(`documents/getLinkByRemainderDZ/${id}`);
  },
  getECPInfoHistoryFile(projectID, idFile) {
    return ApiService.get(
      `documents/getECPInfoHistoryFile/${projectID}/${idFile}`
    );
  },
  getECPInfoHistoryFileDZ(projectID, idFile) {
    return ApiService.get(
      `documents/getECPInfoHistoryFileDZ/${projectID}/${idFile}`
    );
  },
  getDopInfoDataProject(id) {
    return ApiService.get(`dopinfo/getDopInfoDataProject/${id}`);
  },
  getListIndicatorsOrgs(id) {
    return ApiService.get(`projects/getListIndicatorsOrgs/${id}`);
  },
  getIndicatorsByOrg(id) {
    return ApiService.get(`indicatorsOrg/getIndicatorsByOrg/${id}`);
  },
  getListBalansSp() {
    return ApiService.get(`indicatorsOrg/getListBalansSp`);
  },
  getListFinanceResultSp() {
    return ApiService.get(`indicatorsOrg/getListFinanceResultSp`);
  },
  getListAmortizationSp() {
    return ApiService.get(`indicatorsOrg/getListAmortizationSp`);
  },
  setIndicatorsByOrg(idOrg, idStatus, params) {
    return ApiService.post(
      `indicatorsOrg/setIndicatorsByOrg/${idOrg}/${idStatus}/`,
      params
    );
  },
  setBalansByOrg(idOrg, idStatus, params) {
    return ApiService.post(
      `indicatorsOrg/setBalansByOrg/${idOrg}/${idStatus}/`,
      params
    );
  },
  setFinanceByOrg(idOrg, idStatus, params) {
    return ApiService.post(
      `indicatorsOrg/setFinanceByOrg/${idOrg}/${idStatus}/`,
      params
    );
  },
  setIsNotFinance(idOrg, idStatus, params) {
    console.log(params);
    return ApiService.post(
      `orgs/setIsNotFinance/${idOrg}/${idStatus}/`,
      params
    );
  },
  getCashflowsByCompany(idOrg) {
    return ApiService.get(`indicatorsCashflows/getCashflowsByCompany/${idOrg}`);
  },
  setCashflowsByCompany(idOrg, params) {
    return ApiService.post(
      `indicatorsCashflows/setCashflowsByCompany/${idOrg}`,
      params
    );
  },
  editDopInfoDataProject(id, params) {
    return ApiService.post(`dopinfo/editDopInfoDataProject/${id}/`, params);
  },
  saveDogovorZaimInfoProject(id, params) {
    return ApiService.post(
      `projects/saveDogovorZaimInfoProject/${id}/`,
      params
    );
  },
  savePlan(id, params) {
    return ApiService.post(`plan/editPlanProject/${id}/`, params);
  },
  setViewDocumentDZForUser(id) {
    return ApiService.post(`documents/setViewDocumentDZForUser/${id}/`);
  },
  clearSessionDocumentDZForUser(id) {
    return ApiService.post(`documents/clearSessionDocumentDZForUser/${id}/`);
  },
  getECPUserInfo(id) {
    return ApiService.get(`/users/getECPUserAuth/${id}`);
  },
  getBaseNameUserSystem(id) {
    return ApiService.get(`/users/getBaseNameUserSystem/${id}`);
  },
  saveTargetProject(id, params) {
    return ApiService.post(`projects/saveTargetsProject/${id}/`, params);
  },
  getTechnologicLinesProject(id) {
    return ApiService.get(`projects/getTechnologicLinesProject/${id}`);
  },
  saveTegnologicalLinesProject(id, params) {
    return ApiService.post(`projects/technologicalLines/save/${id}/`, params);
  },
  getLocationProductsProject(id) {
    return ApiService.get(`projects/getLocationProductsProject/${id}`);
  },
  saveLocationProductsProject(id, params) {
    return ApiService.post(
      `projects/saveLocationProductsProject/save/${id}/`,
      params
    );
  },
  getProductsProject(id) {
    return ApiService.get(`projects/getListProducts/${id}`);
  },
  saveProductsProject(id, params) {
    return ApiService.post(`projects/saveProductsProject/save/${id}/`, params);
  },
  getLinkByFileFLowDZ(id, idFile, params) {
    return ApiService.query(`documents/getLinkByFileFLowDZ/${id}/${idFile}/`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  setReturnStatusProjectCE(id) {
    return ApiService.post(`projects/setReturnStatusProjectCE/${id}/`);
  },
  setReadEtapPause(id, params) {
    return ApiService.post(`projects/setReadEtapPause/${id}/`, params);
  },
  addPause(id, form, params) {
    return ApiService.postForm(`projects/addPause/${id}`, form, params);
  },
  deletePause(id, rowId) {
    return ApiService.delete(`projects/deletePause/${id}/${rowId}`);
  },
  editSettingProjectField(id, field, params) {
    return ApiService.post(
      `projects/editSettingProjectField/${id}/${field}`,
      params
    );
  },
  editProjectField(id, field, params) {
    return ApiService.post(
      `projects/editProjectField/${id}/${field}`,
      params
    );
  },
  editUfSettingProject(id, field, params) {
    return ApiService.post(
      `projects/editUfSettingProject/${id}/${field}`,
      params
    );
  },
  setRegionZaimSum(id, params) {
    return ApiService.post(`projects/setRegionZaimSum/${id}/`, params);
  },
  compareBGDocumentDZ(id, params) {
    return ApiService.post(`documents/compareBGDocumentDZ/${id}`, params);
  },
  clearCache(projectId) {
    return ApiService.post(`projects/clearCache/${projectId}`);
  },
  addEqipmentProject(id, nameEquipment, params) {
    return ApiService.post(`projects/equipment/${id}/${nameEquipment}/add`, params);
  },
  saveEqipmentProject(id, nameEquipment, idEqupment, params) {
    return ApiService.post(`projects/equipment/${id}/${nameEquipment}/save/${idEqupment}`, params);
  },
  deleteEqipmentProject(id, nameEquipment, idEqupment) {
    return ApiService.delete(`projects/equipment/${id}/${nameEquipment}/delete/${idEqupment}`);
  },
};

export const NotificationService = {
  list(id, params) {
    return ApiService.query(`/chat/getListMessageProject/${id}/`, {
      params: params
    });
  },
  addMessageProject(id, params) {
    return ApiService.post(`chat/addMessageProject/${id}/`, params);
  },
  deleteMessageProject(id, messageId) {
    return ApiService.delete(`chat/deleteMessageProject/${id}/${messageId}/`);
  }
};

export const MethodicsService = {
  list(isLizing) {
    return ApiService.get2(`/methodics/getListMethodics/${isLizing}`);
  },
  setNewCountView(id) {
    return ApiService.post(`methodics/setNewCountView/${id}/`);
  }
};

export const ExpertiseService = {
  list(id) {
    return ApiService.get(`/expertises/getListMainDocESExpertise/${id}`);
  },
  getListChatMessageExpertise(id, idExpertise, limit, page, sort) {
    return ApiService.query(
      `expertises/getListChatMessageExpertise/${id}/${idExpertise}/`,
      {
        params: { limit, page, sort },
        paramsSerializer: function({ limit, page, sort }) {
          return qs.stringify({ limit, page, sort }, { encode: false });
        }
      }
    );
    /*
    return ApiService.get(
      `/expertises/getListChatMessageExpertise/${id}/${idExpertise}/`,
      {
        params: { limit, page, sort }
      }
    );*/
  },
  createChatMessageExpertises(id, idExpertise, data) {
    return ApiService.post(
      `/expertises/createChatMessageExpertises/${id}/${idExpertise}`,
      data
    );
  },
  editChatMessageExpertises(id, idExpertise, idMess, data) {
    return ApiService.post(
      `/expertises/editChatMessageExpertises/${id}/${idExpertise}/${idMess}/`,
      data
    );
  },
  deleteChatMessageExpertisesFile(id, idExpertise, idMess, idFile) {
    return ApiService.delete(
      `/expertises/deleteChatMessageExpertisesFile/${id}/${idExpertise}/${idMess}/${idFile}`
    );
  },
  getLinkDownloadFileChatExpertise(id, idExpertise, fileId) {
    return ApiService.query(
      `/expertises/getLinkDownloadFileChatExpertise/${id}/${idExpertise}/`,
      {
        params: { file_id: fileId },
        paramsSerializer: function({ file_id: fileId }) {
          return qs.stringify({ file_id: fileId }, { encode: false });
        }
      }
    );
    /*return ApiService.get(
      `/expertises/getLinkDownloadFileChatExpertise/${id}/${idExpertise}/`,
      {
        params: { file_id: fileId }
      }
    );*/
  },
  getExpertiseDetails(projectId, expertiseId) {
    return ApiService.get(
      `/expertises/getListMainDocESExpertise/${projectId}/?idExpertise=${expertiseId}`
    );
  },
  setBackToWorkExpertises(id, idExpertise) {
    return ApiService.post(
      `/expertises/setBackToWorkExpertises/${id}/${idExpertise}/`
    );
  },
  setSuspendExpertises(id, idExpertise, data) {
    return ApiService.post(
      `/expertises/setSuspendExpertises/${id}/${idExpertise}/`,
      data
    );
  },
  getListExpertises(params) {
    return ApiService.query(`/expertises/getListExpertises/`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  getListAllExpertises(params) {
    return ApiService.query(`/expertises/getListAllExpertises/`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  getListExpertMainDocESExpertise(idTypeExpertise, vidId, idProject) {
    return ApiService.get(
      `expertises/getListExpertMainDocESExpertise/${vidId}/${idTypeExpertise}/${idProject}`
    );
  },
  addMainDocESExpertise(id, params) {
    return ApiService.post(`expertises/addMainDocESExpertise/${id}/`, params);
  },
  addMainDocESExpertiseExpert(id, idExpertise, params) {
    return ApiService.post(
      `expertises/addMainDocESExpertiseExpert/${id}/${idExpertise}/`,
      params
    );
  },
  setDedlineExpertise(id, idExpertise, params) {
    return ApiService.post(
      `expertises/setDedlineExpertise/${id}/${idExpertise}/`,
      params
    );
  },
  saveEndMainDocESExpertise(id, expId) {
    return ApiService.post(
      `expertises/saveEndMainDocESExpertise/${id}/${expId}/`
    );
  },
  saveEndMainDocESExpertiseDop(id, expId) {
    return ApiService.post(
      `expertises/saveEndMainDocESExpertiseDop/${id}/${expId}/`
    );
  },
  saveCommentManagerMainDocESExpertise(id, params) {
    return ApiService.post(
      `expertises/saveCommentManagerMainDocESExpertise/${id}/`,
      params
    );
  },
  saveCommentExpertises(id, idExpertise, params) {
    return ApiService.post(
      `/expertises/saveCommentExpertises/${id}/${idExpertise}/`,
      params
    );
  },
  saveCommentExpertisesDop(id, idExpertise, params) {
    return ApiService.post(
      `/expertises/saveCommentExpertisesDop/${id}/${idExpertise}/`,
      params
    );
  },
  saveResultExpertises(id, idExpertise, params) {
    return ApiService.post(
      `/expertises/saveResultExpertises/${id}/${idExpertise}/`,
      params
    );
  },
  saveResultExpertisesCoathor(id, idExpertise, params) {
    return ApiService.post(
      `/expertises/saveResultExpertisesCoathor/${id}/${idExpertise}/`,
      params
    );
  },
  saveResultExpertisesDop(id, idExpertise, params) {
    return ApiService.post(
      `/expertises/saveResultExpertisesDop/${id}/${idExpertise}/`,
      params
    );
  },
  saveRiskClassExpertises(id, idExpertise, params) {
    return ApiService.post(
      `/expertises/saveRiskClassExpertises/${id}/${idExpertise}/`,
      params
    );
  },
  saveDurationExpertise(id, idExpertise, params) {
    return ApiService.post(
      `/expertises/saveDurationExpertise/${id}/${idExpertise}/`,
      params
    );
  },
  saveTimeStatusCreateExpertises(id, idExpertise, params) {
    return ApiService.post(
      `/expertises/saveTimeStatusCreateExpertises/${id}/${idExpertise}/`,
      params
    );
  },
  saveExpertiseTypeFIEDZ(id, idExpertise, params) {
    return ApiService.post(
      `/expertises/saveExpertiseTypeFIEDZ/${id}/${idExpertise}/`,
      params
    );
  },
  saveExpertiseSconditionDZ(id, idExpertise, params) {
    return ApiService.post(
      `/expertises/saveExpertiseSconditionDZ/${id}/${idExpertise}/`,
      params
    );
  },
  saveExpertiseTypePREDZ(id, idExpertise, params) {
    return ApiService.post(
      `/expertises/saveExpertiseTypePREDZ/${id}/${idExpertise}/`,
      params
    );
  },
  deleteMainDocESExpertise(id, expId) {
    return ApiService.delete(
      `expertises/deleteMainDocESExpertise/${id}/${expId}/`
    );
  },
  getLinkReestrExpertise(params) {
    return ApiService.query("expertises/getLinkReestrExpertisesExcel/", {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  editExpertiseField(id, expId, field, params) {
    return ApiService.post(
      `expertises/editExpertiseField/${id}/${expId}/${field}`,
      params
    );
  }
};

export const ExpertAdvice = {
  getListSubmitted(type, params) {
    return ApiService.query("planExpertAdvice/getListSubmittedProjects/", {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  getListAdvice(params) {
    return ApiService.query(`/planExpertAdvice/getListAdvice/`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  getLinkByFileAdvise(idFile) {
    return ApiService.get(`/services/getLinkFileById/${idFile}`);
  },
  getLinkByFileGenerateAdvise(idRecord) {
    return ApiService.get(
      `/planExpertAdvice/getLinkByFileGenerateAdvise/${idRecord}`
    );
  },
  getProjectAdviceInfo(id, projectId) {
    return ApiService.get(
      `planExpertAdvice/getProjectAdviceInfo/${id}/${projectId}`
    );
  },
  getListProjectsAdvice(id, params) {
    return ApiService.query(`/planExpertAdvice/getListProjectsAdvice/${id}/`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  getLinkReestrAdviceProjectExcel(id, params) {
    return ApiService.query(
      `/planExpertAdvice/getLinkReestrAdviceProjectExcel/${id}/`,
      {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { encode: false });
        }
      }
    );
  },
  getLinkPrintMatrixExcel(id) {
    return ApiService.query(`/planExpertAdvice/getLinkPrintMatrixExcel/${id}/`);
  },
  getLinkExportBilluten(id) {
    return ApiService.query(`/planExpertAdvice/getLinkExportBilluten/${id}/`);
  },
  addPlanExpertAdvice(params) {
    return ApiService.post(`planExpertAdvice/addPlanExpertAdvice/`, params);
  },
  addProjectAdviceDocument(idRow, params) {
    return ApiService.post(
      `planExpertAdvice/addProjectAdviceDocument/${idRow}`,
      params
    );
  },
  editProjectAdviceDocument(idRow, idDoc, params) {
    return ApiService.post(
      `planExpertAdvice/editProjectAdviceDocument/${idRow}/${idDoc}`,
      params
    );
  },
  addProjectAdviceTask(idRow, params) {
    return ApiService.post(
      `planExpertAdvice/addProjectAdviceTask/${idRow}`,
      params
    );
  },
  editPlanExpertAdvice(id, params) {
    return ApiService.post(
      `planExpertAdvice/editPlanExpertAdvice/${id}/`,
      params
    );
  },
  searchProject(params) {
    return ApiService.post(`projects/searchProject/`, params);
  },
  addProjectAdvice(id, params) {
    return ApiService.post(`planExpertAdvice/addProjectAdvice/${id}/`, params);
  },
  editProjectAdvice(id, sid, params) {
    return ApiService.post(
      `planExpertAdvice/editProjectAdvice/${id}/${sid}/`,
      params
    );
  },
  setProjectAdvice(id, sid, params) {
    return ApiService.post(
      `planExpertAdvice/setProjectAdviceSort/${id}/${sid}/`,
      params
    );
  },
  onSendTransferProject(id, sid, params) {
    return ApiService.post(
      `planExpertAdvice/onSendTransferProject/${id}/${sid}/`,
      params
    );
  },
  onSetEndWorkProject(id) {
    return ApiService.post(`planExpertAdvice/onSetEndWorkProject/${id}`);
  },
  setBlockPlanExpertAdvice(id, params) {
    return ApiService.post(
      `planExpertAdvice/setBlockPlanExpertAdvice/${id}/`,
      params
    );
  },
  getItem(id) {
    return ApiService.get(`planExpertAdvice/getItem/${id}`);
  },
  deletePlanExpertAdvice(id) {
    return ApiService.delete(`planExpertAdvice/deletePlanExpertAdvice/${id}/`);
  },
  deleteProjectAdvice(id) {
    return ApiService.delete(`planExpertAdvice/deleteProjectAdvice/${id}/`);
  },
  deleteProjectAdviceDocument(id) {
    return ApiService.delete(
      `planExpertAdvice/deleteProjectAdviceDocument/${id}`
    );
  },
  getProjectAdvice(id, sid) {
    return ApiService.get(`planExpertAdvice/getProjectAdvice/${id}/${sid}`);
  },
  getHistoryProjectAdvice(id) {
    return ApiService.get(`planExpertAdvice/getHistoryProjectAdvice/${id}`);
  },
  getLinkReestrHistoryProjectAdviceExcel(id) {
    return ApiService.get(
      `planExpertAdvice/getLinkReestrHistoryProjectAdviceExcel/${id}`
    );
  },
  getListSortNumberProjectsAdvice(id) {
    return ApiService.get(
      `planExpertAdvice/getListSortNumberProjectsAdvice/${id}`
    );
  },
  getListQuestionAndDocByVote(params) {
    return ApiService.query(
      `planExpertAdvice/voting/listQuestionAndDocByVote/`,
      {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { encode: false });
        }
      }
    );
  },
  setIsNewDocuments(id, params) {
    return ApiService.post(
      `planExpertAdvice/voting/setIsNewDocuments/${id}`,
      params
    );
  },
  getLinkFileArchive(id) {
    return ApiService.get(`planExpertAdvice/voting/getLinkFileArhive/${id}`);
  },
  getLinkFileArchiveAll(id) {
    return ApiService.get(`planExpertAdvice/voting/getLinkFileArhiveAll/${id}`);
  },
  setVoice(id, params) {
    return ApiService.post(`planExpertAdvice/voting/setVoices/${id}`, params);
  },
  setVoiceAll(id, params) {
    return ApiService.post(
      `planExpertAdvice/voting/setVoicesAll/${id}`,
      params
    );
  },
  setPresidentSovet(id, params) {
    return ApiService.post(`planExpertAdvice/setPresidentSovet/${id}`, params);
  },
  setTotalVoices(id, params) {
    return ApiService.post(
      `planExpertAdvice/voting/setTotalVoices/${id}`,
      params
    );
  },
  setTypePositionVoteExpert(id, params) {
    return ApiService.post(
      `planExpertAdvice/voting/setTypePositionVoteExpert/${id}`,
      params
    );
  },
  setVoiceAllExpertByQuestion(id, params) {
    return ApiService.post(
      `planExpertAdvice/voting/setVoiceAllExpertByQuestion/${id}`,
      params
    );
  },
  setCommentExpertBySovet(id, params) {
    return ApiService.post(
      `planExpertAdvice/voting/setCommentExpertBySovet/${id}`,
      params
    );
  },
  saveFileSostavSovet(id, form, params) {
    return ApiService.postForm(
      `planExpertAdvice/saveFileSostavSovet/${id}/`,
      form,
      params
    );
  },
  saveFileProtokolPovestkaSovet(id, form, params) {
    return ApiService.postForm(
      `planExpertAdvice/saveFileProtokolPovestkaSovet/${id}/`,
      form,
      params
    );
  },
  deleteFileSostavSovet(id) {
    return ApiService.delete(`planExpertAdvice/deleteFileSostavSovet/${id}/`);
  },
  deleteFilePovestkaProtokol(id, type) {
    return ApiService.delete(
      `planExpertAdvice/deleteFilePovestkaProtokol/${id}/${type}/`
    );
  },
  saveFileProtokolQuestion(idQuestion, form, params) {
    return ApiService.postForm(
      `planExpertAdvice/saveFileProtokolQuestion/${idQuestion}/`,
      form,
      params
    );
  },
  deleteFileProtokolQuestion(idQuestion) {
    return ApiService.delete(
      `planExpertAdvice/deleteFileProtokolQuestion/${idQuestion}/`
    );
  }
};

export const GroupOrgs = {
  getListGroupOrgs(params) {
    return ApiService.query(`/groupOrgs/getListGroupOrgs/`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  getListOrgs(params) {
    return ApiService.query(`/groupOrgs/getListOrgs/`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  getListOrgsLizing(params) {
    return ApiService.query(`/orgs/getListOrgsLizing/`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  addGroupOrgs(params) {
    return ApiService.post(`groupOrgs/addGroupOrgs/`, params);
  },
  getGroupOrgs(id) {
    return ApiService.get(`groupOrgs/getGroupOrgs/${id}`);
  },
  getRecordOrgGroup(id) {
    return ApiService.get(`groupOrgs/getRecordOrgGroup/${id}`);
  },
  editGroupOrgs(id, params) {
    return ApiService.post(`groupOrgs/editGroupOrgs/${id}/`, params);
  },
  editRecordOrgGroup(id, params) {
    return ApiService.post(`groupOrgs/editRecordOrgGroup/${id}/`, params);
  },
  deleteGroupOrgs(id) {
    return ApiService.delete(`groupOrgs/deleteGroupOrgs/${id}/`);
  }
};

export const MonitoringLizingOrgs = {
  getListMonitoringLizingOrgs(params) {
    return ApiService.query(`/monitorLizing/getListReportByPeriod/`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  getECPInfoFileMonitorLizing(idFile) {
    return ApiService.get(`monitorLizing/getECPInfoFile/${idFile}`);
  },
  saveAcceptDocumentMonitorLizing(id, params) {
    return ApiService.post(`monitorLizing/saveAcceptDocument/${id}/`, params);
  },
  saveDocument(form, params) {
    return ApiService.postForm(`monitorLizing/saveDocument/`, form, params);
  },
  getDocumenetHistory(idFile) {
    return ApiService.get(`monitorLizing/getDocumenetHistory/${idFile}`);
  },
  deleteFile(idFile, actual) {
    return ApiService.delete(`/monitorLizing/deleteFile/${idFile}/${actual}/`);
  },
  getLinkFileArhive(params) {
    return ApiService.query(`/monitorLizing/getLinkFileArchive/`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  getLinkFileECP(id) {
    return ApiService.get(`/monitorLizing/getLinkFileECP/${id}`);
  },
  addRequestDocument(params) {
    return ApiService.post(`monitorLizing/addRequestDocument/`, params);
  },
  editRequestDocument(id, params) {
    return ApiService.post(`monitorLizing/editRequestDocument/${id}/`, params);
  },
  setCommentManagerAccept(id, params) {
    return ApiService.post(
      `monitorLizing/setCommentManagerAccept/${id}/`,
      params
    );
  },
  deleteRequestFile(idFile) {
    return ApiService.delete(`/monitorLizing/deleteRequestFile/${idFile}/`);
  }
};

export const RequestsService = {
  getListRequests(params) {
    return ApiService.query(`/requests/getListRequest/`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  createRequest(params) {
    return ApiService.postForm(`/requests/createRequest/`, params);
  },
  getRequest(id) {
    return ApiService.get(`/requests/getRequest/${id}`);
  },
  getDataRequestByProject(id) {
    return ApiService.get(`/requests/getDataRequestByProject/${id}`);
  },
  getListChatMessageRequest(id, params) {
    return ApiService.query(`/requests/getListChatMessageRequest/${id}`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  editRequestField(id, field, params) {
    return ApiService.post(
      `/requests/editRequestField/${id}/${field}/`,
      params
    );
  },
  changePerformer(id, params) {
    return ApiService.post(`/requests/changePerformer/${id}/`, params);
  },
  getLinkTemplateConformityUrl(id, file_id, type_application) {
    return ApiService.get2(
      `/requests/getLinkDownloadFileRequest/${id}/?file_id=${file_id}&type_application=${type_application}`
    );
  },
  getLinkDownloadFileChatRequest(id, file_id, type_application) {
    return ApiService.get2(
      `/requests/getLinkDownloadFileChatRequest/${id}/?file_id=${file_id}&type_application=${type_application}`
    );
  },
  downloadFileRequest(id, id_file, params) {
    return ApiService.postForm(
      `/requests/downloadFileRequest/${id}/${id_file}/`,
      params
    );
  },
  deleteFileRequest(id, id_file) {
    return ApiService.delete(
      `/requests/deleteFileRequest/${id}/${id_file}/`
    );
  },
  changeResultsMainAgreement(id, params) {
    return ApiService.post(
      `/requests/changeResultsMainAgreement/${id}/`,
      params
    );
  },
  changeApprove(id, params) {
    return ApiService.post(`/requests/changeApprove/${id}/`, params);
  },
  changeDelegateApprove(id, params) {
    return ApiService.post(`/requests/changeDelegateApprove/${id}/`, params);
  },
  changeResultsDelegateAgreement(id, params) {
    return ApiService.post(
      `/requests/changeResultsDelegateAgreement/${id}/`,
      params
    );
  },
  createChatMessageRequest(id, params) {
    return ApiService.postForm(
      `/requests/createChatMessageRequest/${id}/`,
      params
    );
  },
  editChatMessageRequest(id, mId, params) {
    return ApiService.postForm(
      `/requests/editChatMessageRequest/${id}/${mId}/`,
      params
    );
  },
  getListOrgs(params) {
    return ApiService.query(`/orgs/getListOrgs/`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  closeRequest(id) {
    return ApiService.post(`/requests/closeRequest/${id}/`);
  },
  withdrawRequest(id) {
    return ApiService.post(`/requests/withdrawRequest/${id}/`);
  },
  deleteChatMessageRequestFile(id, idMess, idFile) {
    return ApiService.delete(
      `/requests/deleteChatMessageRequestFile/${id}/${idMess}/${idFile}`
    );
  }
};

export const AdminService = {
  getListRequests(params) {
    return ApiService.query(`/admin/getListMenu/`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  getListStatusLoadDocuments(params) {
    return ApiService.query(`/admin/documents/getListStatusLoadDocuments`, {
      params: params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { encode: false });
      }
    });
  },
  getInfoDocument(id) {
    return ApiService.get(`/admin/documents/getInfoDocument/${id}`);
  },
  saveListStatusLoadDocuments(params) {
    return ApiService.post(
      `/admin/documents/saveListStatusLoadDocuments`,
      params
    );
  },
  setInfoDocument(id, params) {
    return ApiService.post(`/admin/documents/setInfoDocument/${id}`, params);
  },
  setCommentAdminDocument(id, params) {
    return ApiService.post(
      `/admin/documents/setCommentAdminDocument/${id}`,
      params
    );
  },
  onAddNewDoc(params) {
    return ApiService.post(`/admin/documents/onAddNewDoc`, params);
  },
};

export const ListService = {
  list(resource) {
    return ApiService.query(`directory/${resource}/`, {});
  }
};
